import React from 'react'
import { TrainingTablevt } from './TrainingTablevt'

export const TrainingContentVT = ({ dateRange, hasFilter }) => {
    return (
        <div className='w-full'>
            <div className=' flex'>
                <p className='text-3366FF p-4 font-semibold text-2xl'>Usuarios</p>
                {/* menu regions/grups? */}
                {/* <div className='flex justify-start items-center'>
                    <div className='border-b-2 border-1990FF'>
                        <p className='text-1990FF p-4 font-bold text-xl hover:bg-[#3366FF33] cursor-pointer'>Región 1</p>
                    </div>
                    <div className='border-b-2 border-1990FF'>
                        <p className='text-1990FF p-4 font-bold text-xl hover:bg-[#3366FF33] cursor-pointer'>Región 2</p>
                    </div>
                    <div className='border-b-2 border-1990FF'>
                        <p className='text-1990FF p-4 font-bold text-xl hover:bg-[#3366FF33] cursor-pointer'>Región 3</p>
                    </div>
                </div> */}
            </div>
            <div>
                <TrainingTablevt dateRange={dateRange} hasFilter={hasFilter}></TrainingTablevt>
            </div>
        </div>
    )
}
